<template>
  <div>
    <button
      type="button"
      class="btn btn-lg btn-primary mr-3"
      @click="openAddProviderModal"
    >
      Disable 2FA
    </button>
    <Modal
      id="disable2fa"
      title="Disable 2FA"
      :toggle="closeModal"
      :loading="loading"
    >
      <h3>Are you sure you want to disable 2FA?</h3>
      <p>
        This would disable 2FA, are you sure you want to continue?
      </p>
      <form @submit.prevent="disable2fa">
        <FormButtons
          :loading="loading"
          :handleCloseModal="closeModal"
          :closeBtnName="`No, Don't Disable 2FA`"
          :btnName="`Yes, Disable 2FA`"
        />
      </form>
    </Modal>
  </div>
</template>

<script>
import { notifications } from "../../../../../../../public/assets/mixins/notifications";
import Modal from "../../../../../../components/utils/Modal/Modal";
import FormButtons from "../../../../../../components/utils/FormButtons/FormButtons";
import CustomInput from "../../../../../../components/utils/CustomInput/CustomInput.vue";
import CustomSelect from "../../../../../../components/utils/CustomSelect/CustomSelect";

export default {
  mixins: [notifications],
  name: "DisableMFAModal",
  data() {
    return {
      loading: false,
    };
  },
  props: ["teamInformation", "refetch"],
  methods: {
    openAddProviderModal() {
      $("#disable2fa").modal("show");
    },
    closeModal() {
      $("#disable2fa").modal("hide");
    },
    async disable2fa() {
      try {
        this.loading = true;
        let response = await this.$store.dispatch("customer/set2FA", {
          id: this.teamInformation.user_id,
          clientid: this.$route.params.clientid,
        });

        this.loading = false;
        this.closeModal();
        this.refetch();
        this.showSuccessNotification(response.message);
      } catch (error) {
        this.loading = false;
        this.showErrorNotification(error.message);
      }
    },
  },
  components: {
    Modal,
    FormButtons,
    CustomInput,
    CustomSelect,
  },
};
</script>
